import { FC } from 'react';
import { Image, Skeleton } from "antd";

import useInfoScreen from '../../useInfoScreen';
import { EditableContent } from "../EditableContent";
import { ScreenButtons } from "../ScreenButtons";
import { ScreenButton } from "../ScreenButton";
import { ScreenLayout } from "../ScreenLayout";
import checked from "../../images/checked.png";
import styles from './index.module.scss'

export const PasswordRecoverySuccessScreen: FC<{ screenId: number }> = ({ screenId }) => {
  const { data, onEdit, loading } = useInfoScreen(screenId);
  if (loading) {
    return <Skeleton active={true} />;
  }
  return(
    <ScreenLayout hiddenTabs>
      <Image
        className={styles.image}
        width={150}
        height={150}
        alt="profile"
        preview={false}
        src={checked}
      />
      <div className={styles.body}>
        <EditableContent type="header" maxLength={90} onSave={onEdit}>
          {data?.header}
        </EditableContent>
        <EditableContent type="body" maxLength={130} onSave={onEdit}>
          {data?.body}
        </EditableContent>
      </div>
      <ScreenButtons>
        <ScreenButton>
          На главную
        </ScreenButton>
      </ScreenButtons>
    </ScreenLayout>
  )
}